import React from 'react';
import './RateButton.css';

function RateButton  ()  {
    return (
        <div>
                        {/* <!-- Button trigger modal --> */}
<button type="button" id='fixedbutton' class="btn btn-primary rateus" data-bs-toggle="modal" data-bs-target="#exampleModal">
  Rate Us
</button>

{/* <!-- Modal --> */}
<div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-5" id="exampleModalLabel">Rate Us</h1>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
       <b> If you like our website then please rate us, your rating is very valuable for us </b>
        <div className='content holds-the-iframe'>
            <iframe className='frame'  src="https://script.google.com/macros/s/AKfycbzkVBYaeitJkuMR-IuoZzRaHNAdtfTYuG-V_FdGwiG2RH3jGJv4f9C14YpRYIfPvqT9/exec" width={'100%'} height={'400px'}></iframe>   
            </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btns btn-secondary closed__button" data-bs-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>
        </div>
    );
}

export default RateButton;
